import Inspections from "./Inspection";
import AddInspection from "./AddInspection";


export default Inspections;
export {AddInspection};